module.exports = __webpack_public_path__ + "img/forward.9e830e02.svg";